import React, { useCallback, useEffect, useState } from 'react';
import { Button, CircularProgress, Grid, Tab, Tabs, Typography } from '@material-ui/core';
import { AddOutlined } from '@material-ui/icons';
import { EditorField } from './form';

let isInitialize = false;
const INTRO_TAB = 'intro';
const fixedTabValue = [INTRO_TAB];
const defaultTab = { title: '', content: '' };

const AdditionalsTab = ({bounty, onSubmit}) => {
  const [loading, setLoading] = useState(false);
  const [currentTab, setCurrentTab] = useState(defaultTab);
  const [tabs, setTabs] = useState([
    { name: 'INTRO', link: 'intro' }
  ]);
  const [currentHashLink, setCurrentHashLink] = useState(INTRO_TAB);
  const [keepingCurValue, setKeepingCurValue] = useState(INTRO_TAB);
  const [additionalTabList, setAdditonalTabList] = useState([]);


  const onUpdateCurrentTab = useCallback(
    (tab) => {
      const { title, value, content } = tab;
      setCurrentTab({ title, content });
      if (value && keepingCurValue !== value) {
        setKeepingCurValue(value);
        setCurrentHashLink(value);
      }
    },
    [setCurrentTab, keepingCurValue, setKeepingCurValue],
  );

  const onNewTab = () => {
    const index = additionalTabList.length + 1;
    const value = `tab_${index}`;
    const newTab = { title: `New Tab ${index}`, value, content: '' };
    setAdditonalTabList([...additionalTabList, newTab]);
    onUpdateCurrentTab(newTab);
    setCurrentHashLink(value);
  };

  const onSwitchTab = (_, value) => {
    const changedTabList = [...additionalTabList];
    if (currentHashLink !== keepingCurValue) {
      const changedIndex = changedTabList.findIndex((item) => item?.value === keepingCurValue);
      if (changedIndex >= 0) {
        changedTabList[changedIndex].value = currentHashLink;
        setAdditonalTabList(changedTabList);
      }
    }
    const selectedTab = changedTabList?.filter((item) => item?.value === value);
    if (!selectedTab?.length) return;
    onUpdateCurrentTab(selectedTab[0]);
    setCurrentHashLink(selectedTab[0]?.value);
  };

  const onChangeTabContent = useCallback(
    (event) => {
      const { name, value } = event.target;
      onUpdateCurrentTab({ ...currentTab, [name]: value });
    },
    [currentTab, onUpdateCurrentTab],
  );

  const onChangeHashLink = (event) => {
    const { value } = event.target;
    setCurrentHashLink(value);
  };

  const onRemoveCurrentTab = () => {
    if (currentHashLink === INTRO_TAB) {
      alert('Cannot remove Intro tab')
      return;
    }
    const updateTabs = additionalTabList.filter((item) => item.value !== keepingCurValue);
    if (!updateTabs.length) {
      const tab = { title: 'New Tab', content: '' };
      onUpdateCurrentTab(tab);
      setCurrentHashLink('new_tab');
      setAdditonalTabList([{ ...tab, value: 'new_tab' }]);
      return;
    }
    onUpdateCurrentTab(updateTabs[0]);
    setCurrentHashLink(updateTabs[0]?.value);
    setAdditonalTabList(updateTabs);
    onHandleSubmit(updateTabs);
  };

  const onHandleSubmit = useCallback(
    (updateTabs = []) => {
      const addTabList = updateTabs.length ? updateTabs : additionalTabList;
      setLoading(true);
      const updatedCurrentContent = { ...currentTab, value: currentHashLink };
      const updatedAdditionalTabs = addTabList?.map((item) => {
        if (item?.value === keepingCurValue) {
          return updatedCurrentContent;
        }
        return item;
      });

      onSubmit({ additionalTab: updatedAdditionalTabs })
        .then(() => {
          onUpdateCurrentTab(updatedCurrentContent);
          setLoading(false);
        })
        .catch(() => setLoading(false));
    },
    [additionalTabList, keepingCurValue, currentTab, currentHashLink, onUpdateCurrentTab],
  );

  const onDropTab = (event) => {
    event.preventDefault();
    const data = event.dataTransfer.getData('text');
    const tabList = event.target.closest("div[role='tablist']");
    let node = event.target.getAttribute('role') === 'tab' ? event.target : event.target.closest('[role="tab"]');
    tabList.insertBefore(document.getElementById(data), node.nextSibling);
    const draggableTabs = [];
    for (let i = 0; i < tabList.childNodes.length; i++) {
      draggableTabs.push(tabList.childNodes[i].id);
    }
    let updateCurTab = null;
    const updatedTabs = draggableTabs.map((value) => {
      const selectedTab = additionalTabList.find((tab) => tab.value === value);
      if (selectedTab.value === data) {
        updateCurTab = selectedTab;
      }
      return selectedTab;
    });
    setAdditonalTabList(updatedTabs);
    onUpdateCurrentTab(updateCurTab);
  };

  const onDragOverTab = (event) => event.preventDefault();

  const onDragStartTab = (event) => event.dataTransfer.setData('text', event.target.id);

  useEffect(() => {
    if (!bounty || !bounty.hasOwnProperty('additionalTab') || isInitialize || additionalTabList.length) return;
    const addTabs = (() => {
      const hasIntroTab = bounty?.additionalTab?.some((tab) => fixedTabValue.includes(tab?.value));
      return hasIntroTab
        ? bounty?.additionalTab
        : [{ title: 'Intro', value: INTRO_TAB, content: '' }, ...bounty?.additionalTab];
    })();
    setAdditonalTabList(addTabs);
    onUpdateCurrentTab(addTabs[0]);
    isInitialize = true;
    return () => {
      isInitialize = false;
    };
  }, [bounty, onUpdateCurrentTab, additionalTabList, setAdditonalTabList]);

  const isFixedValue = fixedTabValue.includes(keepingCurValue);

  return (
    <Grid container>
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item xs={12} md={9} sm={9}>
          <Typography variant="h3" style={{ color: 'rgb(3, 237, 195)' }}>Additional Tabs ({bounty?.name})</Typography>
        </Grid>
        <Grid item xs={12} md={3} sm={3}>
          <Button
            startIcon={<AddOutlined />}
            variant="contained"
            color="primary"
            style={{ float: 'right' }}
            onClick={onNewTab}
          >
            New Additional Tab
          </Button>
        </Grid>
      </Grid>
      <Grid container>
        <Grid
          item
          xs={12}
          md={12}
          sm={12}
          style={{
            margin: '16px 0px',
            background: '#fafafa',
            color: '#4051b5',
            border: '1px solid #ccc',
          }}
        >
          <Tabs
            value={keepingCurValue}
            onChange={onSwitchTab}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
          >
            {additionalTabList?.map((item) => (
              <Tab
                label={item?.title}
                value={item?.value}
                key={item?.value}
                id={item?.value}
                onDrop={onDropTab}
                onDragOver={onDragOverTab}
                onDragStart={onDragStartTab}
                draggable
              />
            ))}
          </Tabs>
        </Grid>
      </Grid>
      <Grid container key={keepingCurValue} style={{ marginTop: 16 }}>
        <Grid container item spacing={2}>
          <Grid item xs={4} sm={4} md={4}>
            <label style={{ fontWeight: 600 }}>Tab Name</label>
            <input
              value={currentTab?.title || ''}
              name="title"
              required
              onChange={onChangeTabContent}
              style={{
                width: '100%',
                padding: 10,
                marginTop: 6,
                border: '1px solid #ccc',
                borderRadius: 6,
                background: '#fff'
              }}
            />
          </Grid>
          <Grid item xs={4} sm={4} md={4}>
            <label style={{ fontWeight: 600 }}>Hash Link</label>
            <input
              value={currentHashLink}
              disabled={isFixedValue}
              required
              onChange={onChangeHashLink}
              style={{
                width: '100%',
                padding: 10,
                marginTop: 6,
                border: '1px solid #ccc',
                borderRadius: 6,
                background: '#fff'
              }}
            />
          </Grid>
          <Grid item xs={4} sm={4} md={4}>
            <div style={{ marginTop: 40, display: 'flex' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={onHandleSubmit}
                disabled={loading}
                startIcon={loading && <CircularProgress size={20} />}
                size="medium"
              >
                Save
              </Button>
              {!isFixedValue && (
                <Button
                  variant="text"
                  color="secondary"
                  onClick={onRemoveCurrentTab}
                  disabled={loading}
                  style={{ marginLeft: 20 }}
                  size="medium"
                >
                  Remove this tab
                </Button>
              )}
            </div>
          </Grid>
        </Grid>
        <Grid container item>
          <div style={{ marginTop: 20, width: '100%' }}>
            <EditorField label="Content" name="content" value={currentTab?.content} onChange={onChangeTabContent} />
          </div>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AdditionalsTab;